import _ from "lodash";
import {
  FETCH_STREAM,
  FETCH_STREAMS,
  CREATE_STREAM,
  DELETE_STREAM,
  EDIT_STREAM,
} from "../actions/type";

const streamReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_STREAMS:
      return { ...state, ..._.mapKeys(action.payload, "id") };
    case FETCH_STREAM:
      return { ...state, [action.payload.metadata.id]: action.payload.record };
    case CREATE_STREAM:
      return { ...state, [action.payload.metadata.id]: action.payload.record };
    case EDIT_STREAM:
      return {
        ...state,
        [action.payload.metadata.parentId]: action.payload.record,
      };
    case DELETE_STREAM:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};

export default streamReducer;
